import React, { useState } from "react";
import { TextField, InputAdornment, useTheme, IconButton } from "@mui/material";
import { useField } from "formik";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const FormTextField = ({
  name,
  label,
  type = "text",
  disabled = false,
  placeholder,
  startIcon,
  endIcon,
  ...props
}) => {
  const theme = useTheme();
  const [field, meta] = useField(name);

  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const errorText = meta.touched && meta.error ? meta.error : "";

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      disabled={disabled}
      {...field}
      {...props}
      type={isPassword ? (showPassword ? "text" : "password") : type}
      label={label}
      placeholder={placeholder}
      fullWidth
      variant="outlined"
      error={!!errorText}
      helperText={errorText}
      margin="dense"
      autoComplete="off" // 👈 helps prevent autofill
      onWheel={(e) => type === "number" && e.target.blur()}
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : (
          props.InputProps?.startAdornment || null
        ),

        endAdornment: isPassword ? (
          <InputAdornment position="end">
            <IconButton onClick={handleTogglePassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ) : endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : (
          props.InputProps?.endAdornment || null
        ),

        ...props.InputProps,
      }}
    />
  );
};

export default FormTextField;
